import React, { useContext, useState } from 'react';
import { validateString } from './validation';
import { BookContent, LanguageContextData } from './types';
import { textValues, LanguageContext } from './utils';

interface BookContentFormProps {
  bookContent: BookContent,
  setBookContent: (bookContent: BookContent) => void,
};

const BookContentForm = ({ bookContent, setBookContent }: BookContentFormProps) => {
  const { language } = useContext<LanguageContextData>(LanguageContext);
  const [ title, setTitle ] = useState<string>(bookContent.title);
  const [ text, setText ] = useState<string[]>(bookContent.text);

  const setParagraph = (index: number, paragraph: string): void => {
    const newText = [ ...text ];
    newText[index] = paragraph;
    setText(newText);
  };

  const removeParagraph = (index: number): void => {
    const newText = [ ...text ]
    newText.splice(index, 1);
    setText(newText);
  };

  const appendParagraph = (): void => {
    const newText = [ ...text, ' ' ];
    setText(newText);
  };

  return (
    <article>
      <h1>{ textValues[language]['content'] }</h1>
      <form>
        <h2>{ textValues[language]['contentTitle'] }</h2>
        <input className={ !!!validateString(title, 3, 100) ? 'error' : '' } type='text' id='title' value={ title } onChange={ (e) => setTitle(e.target.value) }/>
        <h2>{ textValues[language]['contentText'] }</h2>
        { text.map((paragraph, index) => (
          <div key={ index }>
            { index === text.length - 1 && text.length > 2 && <p className='right'><button onClick={ (e) => { e.preventDefault(); removeParagraph(index) } }>{ textValues[language]['contentDelete'] }</button></p> }
            <textarea className={ !!!validateString(paragraph, 3, 1000) ? 'error' : '' } onChange={ (e) => setParagraph(index, e.target.value) } value={ paragraph } />
          </div>
        )) }
        <div>
          { text.length <= 16 && <p className='right'><button onClick={ (e) => { e.preventDefault(); appendParagraph() } }>{ textValues[language]['contentAdd'] }</button></p> }
        </div>
        <div className='row'>
          &nbsp;
          <button disabled={ !!!(validateString(title, 3, 100) && text.length >= 1 && text.length <= 16 && text.filter(paragraph => !!!validateString(paragraph, 3, 1000)).length === 0) } onClick={ (e) => { e.preventDefault(); setBookContent({ text, title }) }}>{ textValues[language]['contentButton'] }</button> 
        </div>
      </form>
    </article>
  );
};
export default BookContentForm;